import React, { useState } from 'react';
import styled from 'styled-components';
import { TableSimple, TableProps } from './table-simple';
import { Collapse } from './collapse';

export interface TableMultipleProps {
  data?: TitledTable[];
}

export interface TitledTable {
  title: string;
  table: TableProps;
}
const Elements = (props: React.HTMLAttributes<HTMLDivElement>) => <div {...props} />;

const Element = (props: React.HTMLAttributes<HTMLDivElement>) => <div {...props} />;

const Title = styled.b<{ isOpen: boolean }>`
  color: var(--theme-color-primary);
  cursor: pointer;
  display: flex;
  font-family: var(--theme-typography-primary-font);
  font-size: 22px;
  gap: var(--spacer-s);
  line-height: 30px;
  margin: 0 0 ${(props) => (props.isOpen ? '0' : 'var(--spacer-s)')};
  position: relative;
`;

const Content = styled.div<{ isOpen: boolean }>`
  display: ${(props) => (props.isOpen ? 'block' : 'none')};
`;

export const TableMultiple = (props: TableMultipleProps) => {
  const { data } = props;

  const [openIndex, setOpenIndex] = useState(0);

  const toggleElement = (index: number) => {
    setOpenIndex(index === openIndex ? -1 : index);
  };

  return (
    <Elements>
      {data?.map((field, index) => {
        const hasValue = field?.table?.data?.some((row) => row.value);

        return hasValue ? (
          <Element key={index}>
            <Title isOpen={index === openIndex} onClick={() => toggleElement(index)}>
              <Collapse opened={index === openIndex} />
              {field.title}
            </Title>
            <Content isOpen={index === openIndex}>
              <TableSimple data={field.table.data} />
            </Content>
          </Element>
        ) : null;
      })}
    </Elements>
  );
};

export default TableMultiple;
